import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import App from './App';
import log from 'loglevel';
import configureStore from './createstore'

/*
 * Root React element
 */

log.setDefaultLevel('warn')
if (process.env.NODE_ENV === 'production')
  log.setLevel('warn')
else
  log.setLevel('debug')

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js